// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2Rigg","item":"PaymentsMobile_item__1GDR0","label":"PaymentsMobile_label__kzdPJ","amount":"PaymentsMobile_amount__21mXP"};